import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { QUERY_FIND_OBJECT } from 'graphql/queries/customObjects';
import { useDropdownsData } from 'views/backoffice/BusinessEntities/hooks';
import { getPropertiesById } from 'views/backoffice/BusinessEntities/utils';
import { FindObjects, FindObjectsVariables } from 'views/backoffice/CustomObjects/types';

export const useObjectFromMetadata = (fieldName: string) => {
    const { metadataFieldsByDisplayName } = useDropdownsData();
    const [loading, setLoading] = useState(true);

    const [findObjects, { data: objectData, loading: loadingFindObjects }] = useLazyQuery<FindObjects, FindObjectsVariables>(
        QUERY_FIND_OBJECT,
        {
            onCompleted() {
                setLoading(false);
            }
        }
    );

    const objectPropertiesById = getPropertiesById(objectData?.findObjects, metadataFieldsByDisplayName[fieldName]);

    useEffect(() => {
        if (metadataFieldsByDisplayName[fieldName]) {
            const objectId = metadataFieldsByDisplayName[fieldName]?.objectDefinition?.id;
            if (objectId) {
                findObjects({ variables: { data: { ids: [+objectId] } } });
            }
        }
    }, [fieldName, findObjects, metadataFieldsByDisplayName]);

    return {
        objectPropertiesById,
        loading: loadingFindObjects || loading
    };
};
